export const ErrorIcon = () => (
  <svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="98" height="98" rx="12" fill="#FF5630" fillOpacity="0.16" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49 26.5C36.5736 26.5 26.5 36.5736 26.5 49C26.5 61.4264 36.5736 71.5 49 71.5C61.4264 71.5 71.5 61.4264 71.5 49C71.5 43.0326 69.1295 37.3097 64.9099 33.0901C60.6903 28.8705 54.9674 26.5 49 26.5ZM49 60.25C47.7574 60.25 46.75 59.2426 46.75 58C46.75 56.7574 47.7574 55.75 49 55.75C50.2426 55.75 51.25 56.7574 51.25 58C51.25 59.2426 50.2426 60.25 49 60.25ZM49 53.5C50.2426 53.5 51.25 52.4926 51.25 51.25V40C51.25 38.7574 50.2426 37.75 49 37.75C47.7574 37.75 46.75 38.7574 46.75 40V51.25C46.75 52.4926 47.7574 53.5 49 53.5Z"
      fill="#FF5630"
    />
  </svg>
);
